import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

export function Button({
  variant = 'secondary',
  size = 'md',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseClasses =
    'font-mono uppercase tracking-wider transition-all duration-200 border font-medium';

  const variantClasses = {
    primary: 'bg-namm-text text-namm-bg border-namm-text hover:shadow-[0_0_20px_rgba(0,229,255,0.18)] hover:-translate-y-0.5',
    secondary: 'bg-transparent text-namm-text border-namm-line hover:border-namm-cyan hover:text-namm-cyan hover:shadow-[0_0_20px_rgba(0,229,255,0.18)] hover:-translate-y-0.5',
    danger: 'bg-transparent text-namm-danger border-namm-danger hover:bg-namm-danger hover:text-white hover:-translate-y-0.5',
    ghost: 'bg-transparent text-namm-muted border-transparent hover:text-namm-text hover:border-namm-line',
  };

  const sizeClasses = {
    sm: 'px-3 py-1.5 text-[10px]',
    md: 'px-4 py-2.5 text-[11px]',
    lg: 'px-6 py-3 text-xs',
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
